export const inputCssNoMy =
  "h-9 border dark:border-[#434343] px-2 rounded-md " +
  "hover:border hover:border-blue-200 hover:border-2 " +
  "focus-visible:outline-none focus-visible:border-blue-600 focus-visible:border-2 focus-visible:shadow-sm focus-visible:shadow-blue-800 " + // focus visible
  "dark:bg-[#434343] " +
  "duration-1000 transition-[box-shadow] " +
  "disabled:text-her-lightgray2 " +
  "text-base ";

export const inputCss = inputCssNoMy + "my-2 ";

export const selectCssNoMy =
  "h-9 border dark:border-[#434343] px-2 rounded-md " + //
  "hover:border-blue-200 hover:border-2 " +
  "dark:bg-[#434343] ";

export const selectCss = selectCssNoMy + "my-2 ";

export const textareaCss =
  "border dark:border-[#434343] w-full my-2 px-2 rounded-md mb-1 " +
  "hover:border-blue-200 hover:border-2 " +
  "focus-visible:outline-none focus-visible:border-blue-600 focus-visible:border-2 focus-visible:shadow-sm focus-visible:shadow-blue-800 " + // focus visible
  "dark:bg-[#434343]  " +
  "duration-1000 transition-[box-shadow] " +
  "disabled:text-her-lightgray2 " +
  "text-base ";

export const profileGridCss = "grid grid-cols-1 md:grid-cols-[200px_200px] gap-2 items-center";
